import { CloseOutlined } from '@ant-design/icons';
import { Button, Col, Row } from 'antd';
import PropTypes from 'prop-types';
import React, { useCallback, useEffect, useState } from 'react';

import { useContatosContext } from '../../../../../contexts/ContatosContexto';
import { formatarCnpjCpfIMask } from '../../../../../helpers/formatador';
import { Switch as SwitchAntd } from '../../styles';
import SelectClienteEndereco from '../SelectClienteEndereco';
import {
  CardLine,
  CardSelectedCliente,
  FormLabel,
  SwitchLabel,
} from './styles';

export default function FormSelectClienteOrigemDestino({
  label,
  clienteOrigemDestino,
  setClienteOrigemDestino,
  disabled,
  setAlertMessageErrors,
  dadosPagador,
  tipo,
  clienteExpedidor,
}) {
  const [switchAtivo, setSwitchInativo] = useState(false);
  const [
    isClienteOrigemDestinoIgualPagador,
    setIsClienteOrigemDestinoIgualPagador,
  ] = useState(false);
  const { removeContatoAction, addContatoAction } = useContatosContext();

  const emailsFromExpedidor = clienteExpedidor.flatMap(
    cli => cli.clienteEmails
  );
  const emailsFromRemetente = clienteOrigemDestino.flatMap(
    cli => cli.clienteEmails
  );

  const validateClienteEmails = async email => {
    const emailsFromPagador = [];
    dadosPagador.clienteEmails.forEach(emailPagador => {
      emailsFromPagador.push(emailPagador);
    });

    if (
      !emailsFromExpedidor.includes(email) &&
      !emailsFromPagador.includes(email)
    ) {
      removeContatoAction(email);
    }
  };

  const deleteCliente = idClienteEndereco => {
    setIsClienteOrigemDestinoIgualPagador(false);
    const clientes = clienteOrigemDestino.filter(
      cliente => cliente.idClienteEndereco !== idClienteEndereco
    );

    if (tipo === 'Remetente') {
      const clienteRemovido = clienteOrigemDestino.filter(
        cliente => cliente.idClienteEndereco === idClienteEndereco
      );

      if (clienteRemovido) {
        clienteRemovido[0].clienteEmails.forEach(email => {
          validateClienteEmails(email);
        });
      }
    }
    setClienteOrigemDestino(clientes);
  };

  const copyDadosPagador = useCallback(
    pagador => {
      if (!dadosPagador.id_cliente_endereco) return;

      const dadosPagadorEndereco = {
        bairro: pagador.bairro,
        cep: pagador.cep,
        cidade: pagador.cidade,
        cnpj: pagador.cnpj,
        endereco: pagador.endereco,
        estado: pagador.uf,
        nomeCliente: pagador.razao_social,
        idCliente: pagador.id,
        idCidade: pagador.id_cidade,
        idClienteEndereco: pagador.id_cliente_endereco,
        ibgeCidade: pagador.ibge_cidade,
        idEstado: pagador.id_estado,
        clienteEmails: pagador.clienteEmails,
      };
      setClienteOrigemDestino([dadosPagadorEndereco]);
    },
    [dadosPagador, setClienteOrigemDestino]
  );

  const setClienteOrigemDestinoIgualPagador = value => {
    if (value) {
      if (!dadosPagador.id_cliente_endereco) return;

      if (tipo === 'Remetente') {
        if (emailsFromRemetente) {
          emailsFromRemetente.forEach(email => {
            validateClienteEmails(email);
          });
        }
      }

      setIsClienteOrigemDestinoIgualPagador(true);
      copyDadosPagador(dadosPagador);

      if (tipo === 'Remetente' && dadosPagador) {
        dadosPagador.clienteEmails.forEach(email => {
          if (email) {
            addContatoAction(email);
          }
        });
      }
    } else {
      setIsClienteOrigemDestinoIgualPagador(false);
      setClienteOrigemDestino([]);
    }
  };

  useEffect(() => {
    const hasPagador = Object.keys(dadosPagador).length > 0;

    if (hasPagador && !dadosPagador.id_cliente_endereco) {
      setSwitchInativo(true);
      setIsClienteOrigemDestinoIgualPagador(false);
      return;
    }

    if (disabled || !hasPagador) {
      setSwitchInativo(true);
      return;
    }

    if (!clienteOrigemDestino) {
      setIsClienteOrigemDestinoIgualPagador(false);
    }

    if (clienteOrigemDestino.length > 0 || hasPagador) {
      setSwitchInativo(false);

      const clienteOrigemDestinoIsPagador = clienteOrigemDestino.some(
        cliente => cliente.idCliente === dadosPagador.id
      );

      if (clienteOrigemDestinoIsPagador) {
        setIsClienteOrigemDestinoIgualPagador(true);
        return;
      }

      if (
        !clienteOrigemDestinoIsPagador &&
        isClienteOrigemDestinoIgualPagador
      ) {
        copyDadosPagador(dadosPagador);
      }
    }
  }, [
    disabled,
    dadosPagador,
    clienteOrigemDestino,
    copyDadosPagador,
    isClienteOrigemDestinoIgualPagador,
  ]);

  return (
    <>
      <Row>
        <Col span={24}>
          <Row style={{ marginBottom: 6, justifyContent: 'space-between' }}>
            <Col>
              <FormLabel>{label}</FormLabel>
            </Col>
            <Col>
              <SwitchLabel level={4}>Copiar cliente pagador</SwitchLabel>
              <SwitchAntd
                disabled={switchAtivo}
                defaultChecked
                size="default"
                checked={isClienteOrigemDestinoIgualPagador}
                onChange={setClienteOrigemDestinoIgualPagador}
              />
            </Col>
          </Row>
          <SelectClienteEndereco
            clienteOrigemDestino={clienteOrigemDestino}
            setClienteOrigemDestino={setClienteOrigemDestino}
            disabled={disabled}
            setAlertMessageErrors={setAlertMessageErrors}
            hasPagadorAsClienteOrigemDestino={
              isClienteOrigemDestinoIgualPagador
            }
            tipo={tipo}
          />
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <CardSelectedCliente>
            {clienteOrigemDestino.map(clienteEndereco => (
              <CardLine key={clienteEndereco.idClienteEndereco}>
                <Col span={20}>
                  <p>
                    {`${clienteEndereco.nomeCliente} - ${formatarCnpjCpfIMask(
                      clienteEndereco.cnpj
                    )}`}
                  </p>
                  <p style={{ textTransform: 'capitalize' }}>
                    {`${clienteEndereco.endereco}, ${clienteEndereco.cidade} - ${clienteEndereco.estado}`}
                  </p>
                </Col>
                <Col span={4}>
                  <Row justify="end" style={{ marginTop: '7px' }}>
                    <Button
                      aria-label="removeRementeDestinatario"
                      disabled={disabled}
                      type="link"
                      icon={
                        <CloseOutlined
                          style={{ fontSize: '16px', color: '#8C8C8C' }}
                        />
                      }
                      onClick={() =>
                        deleteCliente(clienteEndereco.idClienteEndereco)
                      }
                    />
                  </Row>
                </Col>
              </CardLine>
            ))}
          </CardSelectedCliente>
        </Col>
      </Row>
    </>
  );
}

FormSelectClienteOrigemDestino.propTypes = {
  label: PropTypes.string.isRequired,
  clienteOrigemDestino: PropTypes.arrayOf(PropTypes.any).isRequired,
  setClienteOrigemDestino: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
  setAlertMessageErrors: PropTypes.func.isRequired,
  dadosPagador: PropTypes.shape({
    id: PropTypes.number,
    id_cliente_endereco: PropTypes.number,
    bairro: PropTypes.string,
    cep: PropTypes.string,
    cidade: PropTypes.string,
    cnpj: PropTypes.string,
    endereco: PropTypes.string,
    uf: PropTypes.string,
    razao_social: PropTypes.string,
    id_cidade: PropTypes.number,
    ibge_cidade: PropTypes.number,
    id_estado: PropTypes.number,
    clienteEmails: PropTypes.arrayOf(PropTypes.any),
  }),
  tipo: PropTypes.string.isRequired,
  clienteExpedidor: PropTypes.arrayOf(PropTypes.any),
};

FormSelectClienteOrigemDestino.defaultProps = {
  dadosPagador: null,
  clienteExpedidor: [],
};
